<template>
  <div class="NewsDetail">
    <section-header heading="2" :ja="title"/>
    <div>
      <div class="text-area" v-html="description"></div>
    </div>
    <sub-btn @click="onMessageList()">あなたへのお知らせ一覧に戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "MessageDetail",
  components: {SectionHeader, SubBtn},
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  mounted(){
    const cmdNo = pb.NewsReq.CommandNo.COMMAND_NO
    const message = pb.NewsReq.create({
      id: this.$route.params.id
    })
    const encoded = pb.NewsReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.NewsResp.Status.SUCCESS) {
          this.title = decoded.title
          this.img = decoded.imgFlg ? process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + decoded.imgPath : ''
          this.description = decoded.description
        } else {
          this.$_error('Error', { title: 'あなたへのお知らせ詳細', statusCode: 100 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'あなたへのお知らせ詳細', statusCode: 100 })
      })
  },
  methods: {
    onMessageList() {
      this.$router.push('/MessageList')
    }
  }
}
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;
    img {
      max-width: 100%;
    }
    .edge {
      box-shadow: 0 0 5px rgba(0,0,0,0.12);
    }
    p {
      margin-top: 1em;
    }
    a {
      color: #f25181;
      text-decoration: none;
    }
  }
}
</style>
